import { render } from "./LessonsList.vue?vue&type=template&id=05a5acca&scoped=true"
import script from "./LessonsList.vue?vue&type=script&lang=js"
export * from "./LessonsList.vue?vue&type=script&lang=js"

import "./LessonsList.vue?vue&type=style&index=0&id=05a5acca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a5acca"]])

export default __exports__